<template>
  <div id="app" :data-ver="version" mg-stat-page="score_newHome" mg-stat-autopv="false">
    <router-view v-if="isInit" />
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { getUserInfo, getDeviceInfo, getServerUserInfo } from '@/utils/service'
import Report from '@/utils/report'
import { isInApp, monitorPageVisibility, isIphoneXRS } from '@/utils/mUtil'
import { version } from '../../../package.json'
import Utils from '../../utils/utils'

export default {
  data() {
    return {
      isInit: false,
      version,
    }
  },
  async created() {
    window.prefix = /ipad/.test(navigator.userAgent.toLowerCase())
      ? 'imgotvhd://'
      : 'imgotv://'
    window.Report = Report

    this.$store.commit('setIsMGTV', isInApp())
    this.$store.commit('setIsIphoneXRS', isIphoneXRS())

    await this.initInfo()
    this.initEruda()
    this.$store.dispatch('queryCashUserInfo')

    try {
      const isUniqVer = await Utils.isSpecialVersion()

      this.$store.commit('setIsSpecialVersion', isUniqVer)
    } catch (error) {
      console.error('setIsSpecialVersion error: ', error)
    }
  },
  mounted() {},
  methods: {
    // 获取用户信息和设备信息
    async initInfo() {
      try {
        // await this.$store.dispatch('getShowState')
        const USERINFO = await getUserInfo()
        const DEVICEINFO = await getDeviceInfo()

        window.USERINFO = USERINFO
        window.DEVICEINFO = DEVICEINFO
        if (USERINFO.uuid && USERINFO.ticket) {
          this.$store.commit('setIfLogin', true)
        }
        await this.$store.dispatch('getTaskInfo')
        this.$store.commit('setUserInfo', USERINFO)
        this.$store.commit('setDevicesInfo', DEVICEINFO)
      } catch (error) {
        console.log('布码' + error)
      } finally {
        this.isInit = true
      }
    },

    initEruda() {
      const isDebug = window.location.href.indexOf('debug') > -1

      if (isDebug) {
        const script = document.createElement('script')
        script.src =
          'https://cdn.bootcdn.net/ajax/libs/eruda/2.4.1/eruda.min.js'
        document.body.appendChild(script)
        script.onload = () => {
          window.eruda.init()
        }
      }
    },
  },
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
